var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CashRegisterWidget.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-38edd7b0!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CashRegisterWidget.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/widgets/CashRegisterWidget.vue
// module id = 711
// module chunks = 0